<template>
  <div>
    {{ rowData.status | StringFormatter("DATALINK_STATUS") }}
  </div>
</template>

<script>
export default {
  props: ["rowData"],
};
</script>
